import isObject from "lodash/isObject";
import keyBy from "lodash/keyBy";
import transform from "lodash/transform";

const findAndPopulateCollection = (
  obj: any,
  keystr: string,
  collection: any
) => {
  const iterateObject = (obj: any) => {
    // the inner function which will be called recursivley
    return transform(obj, (result: any, value: any, key: any) => {
      // transform to a new object
      if (value === keystr) {
        obj.collection = collection;
      }

      if (isObject(value)) {
        result[key] = iterateObject(value);
      } else result[key] = value; // if the key is an object run it through the inner function - omitFromObject
    });
  };

  return iterateObject(obj); // return the inner function result
};
export default findAndPopulateCollection;
